import Header from '../../Components/Header'
import ContactUsComponent from "../../Components/ContactUsComponent"

const ContactUsPage = () => {
  return (
    <div>
        <Header/>
        <ContactUsComponent/>
    </div>
  )
}

export default ContactUsPage